/**
 * @param color - The color to use for the QR code pattern
 * @returns SVG data URI string
 */
export function generateQRCodeSvgDataUri(color: string): string {
  const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 500 500">
    <defs>
      <clipPath id="clip-qr">
        <rect x="12" y="240" width="19" height="19"/>
        <rect x="12" y="259" width="19" height="19"/>
        <rect x="12" y="278" width="19" height="19"/>
        <rect x="12" y="297" width="19" height="19"/>
        <rect x="31" y="221" width="19" height="19"/>
        <rect x="31" y="297" width="19" height="19"/>
        <rect x="50" y="202" width="19" height="19"/>
        <rect x="50" y="240" width="19" height="19"/>
        <rect x="50" y="259" width="19" height="19"/>
        <rect x="69" y="164" width="19" height="19"/>
        <rect x="69" y="202" width="19" height="19"/>
        <rect x="69" y="221" width="19" height="19"/>
        <rect x="69" y="240" width="19" height="19"/>
        <rect x="69" y="297" width="19" height="19"/>
        <rect x="88" y="183" width="19" height="19"/>
        <rect x="88" y="202" width="19" height="19"/>
        <rect x="88" y="297" width="19" height="19"/>
        <rect x="88" y="316" width="19" height="19"/>
        <rect x="107" y="164" width="19" height="19"/>
        <rect x="107" y="202" width="19" height="19"/>
        <rect x="107" y="259" width="19" height="19"/>
        <rect x="107" y="278" width="19" height="19"/>
        <rect x="107" y="316" width="19" height="19"/>
        <rect x="126" y="164" width="19" height="19"/>
        <rect x="126" y="202" width="19" height="19"/>
        <rect x="126" y="240" width="19" height="19"/>
        <rect x="126" y="278" width="19" height="19"/>
        <rect x="126" y="316" width="19" height="19"/>
        <rect x="145" y="164" width="19" height="19"/>
        <rect x="145" y="183" width="19" height="19"/>
        <rect x="145" y="202" width="19" height="19"/>
        <rect x="145" y="221" width="19" height="19"/>
        <rect x="145" y="240" width="19" height="19"/>
        <rect x="145" y="259" width="19" height="19"/>
        <rect x="145" y="297" width="19" height="19"/>
        <rect x="145" y="316" width="19" height="19"/>
        <rect x="164" y="31" width="19" height="19"/>
        <rect x="164" y="50" width="19" height="19"/>
        <rect x="164" y="126" width="19" height="19"/>
        <rect x="164" y="221" width="19" height="19"/>
        <rect x="164" y="259" width="19" height="19"/>
        <rect x="164" y="316" width="19" height="19"/>
        <rect x="164" y="354" width="19" height="19"/>
        <rect x="164" y="373" width="19" height="19"/>
        <rect x="164" y="411" width="19" height="19"/>
        <rect x="183" y="31" width="19" height="19"/>
        <rect x="183" y="88" width="19" height="19"/>
        <rect x="183" y="164" width="19" height="19"/>
        <rect x="183" y="221" width="19" height="19"/>
        <rect x="183" y="297" width="19" height="19"/>
        <rect x="183" y="316" width="19" height="19"/>
        <rect x="183" y="354" width="19" height="19"/>
        <rect x="183" y="373" width="19" height="19"/>
        <rect x="183" y="411" width="19" height="19"/>
        <rect x="183" y="449" width="19" height="19"/>
        <rect x="183" y="468" width="19" height="19"/>
        <rect x="202" y="12" width="19" height="19"/>
        <rect x="202" y="50" width="19" height="19"/>
        <rect x="202" y="69" width="19" height="19"/>
        <rect x="202" y="88" width="19" height="19"/>
        <rect x="202" y="126" width="19" height="19"/>
        <rect x="202" y="164" width="19" height="19"/>
        <rect x="202" y="183" width="19" height="19"/>
        <rect x="202" y="202" width="19" height="19"/>
        <rect x="202" y="221" width="19" height="19"/>
        <rect x="202" y="240" width="19" height="19"/>
        <rect x="202" y="259" width="19" height="19"/>
        <rect x="202" y="278" width="19" height="19"/>
        <rect x="202" y="297" width="19" height="19"/>
        <rect x="202" y="354" width="19" height="19"/>
        <rect x="202" y="411" width="19" height="19"/>
        <rect x="202" y="430" width="19" height="19"/>
        <rect x="202" y="468" width="19" height="19"/>
        <rect x="221" y="31" width="19" height="19"/>
        <rect x="221" y="69" width="19" height="19"/>
        <rect x="221" y="107" width="19" height="19"/>
        <rect x="221" y="164" width="19" height="19"/>
        <rect x="221" y="202" width="19" height="19"/>
        <rect x="221" y="221" width="19" height="19"/>
        <rect x="221" y="278" width="19" height="19"/>
        <rect x="221" y="297" width="19" height="19"/>
        <rect x="221" y="335" width="19" height="19"/>
        <rect x="221" y="373" width="19" height="19"/>
        <rect x="221" y="411" width="19" height="19"/>
        <rect x="240" y="12" width="19" height="19"/>
        <rect x="240" y="31" width="19" height="19"/>
        <rect x="240" y="50" width="19" height="19"/>
        <rect x="240" y="88" width="19" height="19"/>
        <rect x="240" y="107" width="19" height="19"/>
        <rect x="240" y="126" width="19" height="19"/>
        <rect x="240" y="145" width="19" height="19"/>
        <rect x="240" y="183" width="19" height="19"/>
        <rect x="240" y="259" width="19" height="19"/>
        <rect x="240" y="278" width="19" height="19"/>
        <rect x="240" y="297" width="19" height="19"/>
        <rect x="240" y="316" width="19" height="19"/>
        <rect x="240" y="354" width="19" height="19"/>
        <rect x="240" y="468" width="19" height="19"/>
        <rect x="259" y="31" width="19" height="19"/>
        <rect x="259" y="69" width="19" height="19"/>
        <rect x="259" y="107" width="19" height="19"/>
        <rect x="259" y="183" width="19" height="19"/>
        <rect x="259" y="278" width="19" height="19"/>
        <rect x="259" y="297" width="19" height="19"/>
        <rect x="259" y="316" width="19" height="19"/>
        <rect x="259" y="354" width="19" height="19"/>
        <rect x="259" y="373" width="19" height="19"/>
        <rect x="259" y="449" width="19" height="19"/>
        <rect x="259" y="468" width="19" height="19"/>
        <rect x="278" y="12" width="19" height="19"/>
        <rect x="278" y="31" width="19" height="19"/>
        <rect x="278" y="107" width="19" height="19"/>
        <rect x="278" y="126" width="19" height="19"/>
        <rect x="278" y="145" width="19" height="19"/>
        <rect x="278" y="164" width="19" height="19"/>
        <rect x="278" y="240" width="19" height="19"/>
        <rect x="278" y="297" width="19" height="19"/>
        <rect x="278" y="316" width="19" height="19"/>
        <rect x="278" y="354" width="19" height="19"/>
        <rect x="278" y="411" width="19" height="19"/>
        <rect x="278" y="430" width="19" height="19"/>
        <rect x="278" y="468" width="19" height="19"/>
        <rect x="297" y="50" width="19" height="19"/>
        <rect x="297" y="69" width="19" height="19"/>
        <rect x="297" y="107" width="19" height="19"/>
        <rect x="297" y="164" width="19" height="19"/>
        <rect x="297" y="183" width="19" height="19"/>
        <rect x="297" y="259" width="19" height="19"/>
        <rect x="297" y="278" width="19" height="19"/>
        <rect x="297" y="297" width="19" height="19"/>
        <rect x="297" y="316" width="19" height="19"/>
        <rect x="297" y="373" width="19" height="19"/>
        <rect x="297" y="392" width="19" height="19"/>
        <rect x="297" y="411" width="19" height="19"/>
        <rect x="316" y="12" width="19" height="19"/>
        <rect x="316" y="31" width="19" height="19"/>
        <rect x="316" y="107" width="19" height="19"/>
        <rect x="316" y="126" width="19" height="19"/>
        <rect x="316" y="145" width="19" height="19"/>
        <rect x="316" y="202" width="19" height="19"/>
        <rect x="316" y="316" width="19" height="19"/>
        <rect x="316" y="335" width="19" height="19"/>
        <rect x="316" y="354" width="19" height="19"/>
        <rect x="316" y="373" width="19" height="19"/>
        <rect x="316" y="392" width="19" height="19"/>
        <rect x="316" y="449" width="19" height="19"/>
        <rect x="335" y="164" width="19" height="19"/>
        <rect x="335" y="202" width="19" height="19"/>
        <rect x="335" y="221" width="19" height="19"/>
        <rect x="335" y="240" width="19" height="19"/>
        <rect x="335" y="259" width="19" height="19"/>
        <rect x="335" y="316" width="19" height="19"/>
        <rect x="335" y="392" width="19" height="19"/>
        <rect x="335" y="468" width="19" height="19"/>
        <rect x="354" y="183" width="19" height="19"/>
        <rect x="354" y="316" width="19" height="19"/>
        <rect x="354" y="354" width="19" height="19"/>
        <rect x="354" y="392" width="19" height="19"/>
        <rect x="354" y="468" width="19" height="19"/>
        <rect x="373" y="202" width="19" height="19"/>
        <rect x="373" y="259" width="19" height="19"/>
        <rect x="373" y="316" width="19" height="19"/>
        <rect x="373" y="392" width="19" height="19"/>
        <rect x="392" y="183" width="19" height="19"/>
        <rect x="392" y="240" width="19" height="19"/>
        <rect x="392" y="278" width="19" height="19"/>
        <rect x="392" y="297" width="19" height="19"/>
        <rect x="392" y="316" width="19" height="19"/>
        <rect x="392" y="335" width="19" height="19"/>
        <rect x="392" y="354" width="19" height="19"/>
        <rect x="392" y="373" width="19" height="19"/>
        <rect x="392" y="392" width="19" height="19"/>
        <rect x="392" y="449" width="19" height="19"/>
        <rect x="392" y="468" width="19" height="19"/>
        <rect x="411" y="183" width="19" height="19"/>
        <rect x="411" y="221" width="19" height="19"/>
        <rect x="411" y="259" width="19" height="19"/>
        <rect x="411" y="316" width="19" height="19"/>
        <rect x="411" y="335" width="19" height="19"/>
        <rect x="411" y="392" width="19" height="19"/>
        <rect x="411" y="430" width="19" height="19"/>
        <rect x="411" y="449" width="19" height="19"/>
        <rect x="430" y="164" width="19" height="19"/>
        <rect x="430" y="183" width="19" height="19"/>
        <rect x="430" y="221" width="19" height="19"/>
        <rect x="430" y="278" width="19" height="19"/>
        <rect x="430" y="335" width="19" height="19"/>
        <rect x="430" y="373" width="19" height="19"/>
        <rect x="430" y="392" width="19" height="19"/>
        <rect x="430" y="411" width="19" height="19"/>
        <rect x="430" y="449" width="19" height="19"/>
        <rect x="430" y="468" width="19" height="19"/>
        <rect x="449" y="164" width="19" height="19"/>
        <rect x="449" y="183" width="19" height="19"/>
        <rect x="449" y="240" width="19" height="19"/>
        <rect x="449" y="259" width="19" height="19"/>
        <rect x="449" y="278" width="19" height="19"/>
        <rect x="449" y="316" width="19" height="19"/>
        <rect x="449" y="335" width="19" height="19"/>
        <rect x="449" y="373" width="19" height="19"/>
        <rect x="449" y="392" width="19" height="19"/>
        <rect x="468" y="183" width="19" height="19"/>
        <rect x="468" y="221" width="19" height="19"/>
        <rect x="468" y="240" width="19" height="19"/>
        <rect x="468" y="259" width="19" height="19"/>
        <rect x="468" y="278" width="19" height="19"/>
        <rect x="468" y="316" width="19" height="19"/>
        <rect x="468" y="335" width="19" height="19"/>
        <rect x="468" y="354" width="19" height="19"/>
        <rect x="468" y="411" width="19" height="19"/>
        <rect x="468" y="468" width="19" height="19"/>
        <path clipRule="evenodd" d="M 12 12v 133h 133v -133zM 31 31h 95v 95h -95z"/>
        <rect x="50" y="50" width="57" height="57"/>
        <path clipRule="evenodd" d="M 354 12v 133h 133v -133zM 373 31h 95v 95h -95z" transform="rotate(90,420.5,78.5)"/>
        <rect x="392" y="50" width="57" height="57" transform="rotate(90,420.5,78.5)"/>
        <path clipRule="evenodd" d="M 12 354v 133h 133v -133zM 31 373h 95v 95h -95z" transform="rotate(-90,78.5,420.5)"/>
        <rect x="50" y="392" width="57" height="57" transform="rotate(-90,78.5,420.5)"/>
      </clipPath>
    </defs>
    <rect x="0" y="0" height="500" width="500" clip-path="url(#clip-qr)" fill="${color}"/>
  </svg>`;
  
  return `data:image/svg+xml,${encodeURIComponent(svgContent)}`;
}
